import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/login.css";
import { AuthContext } from "../context/AuthContext";
import Logo from "../images/logoss.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";

// Email regex for validation
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const Login = () => {
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState({
    email: "",
    password: "",
  });

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const onChangeHandler = (e) => {
    setText((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const result = await login({ email: text.email, password: text.password });

      if (result?.status === "unverified") {
        navigate(`/verify-account?email=${encodeURIComponent(result.email)}`);
      } else if (result?.error) {
        setError(result.error);
      } else {
        navigate("/dashboard");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const isEmailValid = emailRegex.test(text.email);
  const isPasswordValid = text.password.length >= 6;
  const isFormValid = isEmailValid && isPasswordValid && !loading;


  return (
    <div className="login-container">
      {/* Left side - background image */}
      <div className="login-left">
        <div className="login-left-content">
          <h2>SubnetExpress</h2>
          <p>Connecting you with fast, reliable, and affordable digital services across Nigeria.</p>
        </div>
      </div>

      {/* Right side - login box */}
      <div className="login-right">
        <div className="login-box">
          <img src={Logo} alt="Logo" className="login-logo" />
          <div className="logo-cont">
            <h2 className="login-title">Welcome Back!</h2>
            <p className="login-subtext">Kindly enter your details to login</p>

            <form onSubmit={onSubmitHandler} className="login-form">
              <div className="input-container input-cont-first" style={{ position: "relative" }}>
                <label>Email</label>
                <input
                  required
                  onChange={onChangeHandler}
                  type="email"
                  name="email"
                  value={text.email}
                  placeholder="Enter your email"
                  className={!isEmailValid && text.email ? "error" : ""}
                />
                {!isEmailValid && text.email && (
                  <p className="error-input">*Please enter a valid email address.</p>
                )}
              </div>

              <div className="input-container">
                <label>Password</label>
                <div className="password-wrapper">
                  <input
                    required
                    onChange={onChangeHandler}
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={text.password}
                    placeholder="Enter your password"
                    className={!isPasswordValid && text.password ? "error" : ""}
                  />
                  <span
                    className="toggle-password"
                    onClick={() => setShowPassword((prev) => !prev)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                {!isPasswordValid && text.password && (
                  <p className="error-input">*Password must be at least 6 characters.</p>
                )}
              </div>

              <div className="forgot-password-link">
                <Link to="/forgot-password">Forgot Password?</Link>
              </div>

                   {error && <p className="error-text error-adj">{error}</p>}

              <button
                type="submit"
                className="login-btn"
                disabled={!isFormValid}
              >
                {loading ? <div className="spinner"></div> : "Login"}
              </button>

         

              <span className="login-footer">
                Don’t have an account? <Link to="/register">Register</Link>
              </span>
            </form>
          </div>
        </div>
      </div>
    </div>
  );

};

export default Login;
